class ColorConstrast {

    constructor(background, foreground) {
        this.background = background
        this.foreground = foreground
    }

    rgbToHex(r, g, b) {
        return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
    }

    rgbToHsl(r, g, b) {
        r /= 255, g /= 255, b /= 255;
        var max = Math.max(r, g, b),
            min = Math.min(r, g, b);
        var h, s, l = (max + min) / 2;

        if (max == min) {
            h = s = 0; // achromatic
        } else {
            var d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            switch (max) {
                case r:
                    h = (g - b) / d + (g < b ? 6 : 0);
                    break;
                case g:
                    h = (b - r) / d + 2;
                    break;
                case b:
                    h = (r - g) / d + 4;
                    break;
            }
            h /= 6;
        }

        return [h, s, l];
    }

    hexToRgb(hex) {
        var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function (m, r, g, b) {
            return r + r + g + g + b + b;
        });

        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

        return result ? [parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16)] : [255, 255, 255];
    }

    hexToHsl(hex) {
        var arr = this.hexToRgb(hex);
        return this.rgbToHsl(arr[0], arr[1], arr[2]);
    }

    hslToHex(h, s, l) {
        var arr = this.hslToRgb(h, s, l);
        return this.rgbToHex(arr[0], arr[1], arr[2]);
    }

    componentToHex(c) {
        var hex = c.toString(16);
        return hex.length == 1 ? "0" + hex : hex;
    }

    hslToRgb(h, s, l) {
        var r, g, b;

        if (s == 0) {
            r = g = b = l; // achromatic
        } else {
            var hue2rgb = function hue2rgb(p, q, t) {
                if (t < 0) t += 1;
                if (t > 1) t -= 1;
                if (t < 1 / 6) return p + (q - p) * 6 * t;
                if (t < 1 / 2) return q;
                if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                return p;
            }

            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            var p = 2 * l - q;
            r = hue2rgb(p, q, h + 1 / 3);
            g = hue2rgb(p, q, h);
            b = hue2rgb(p, q, h - 1 / 3);
        }

        return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
    }

    luminanace(r, g, b) {
        var a = [r, g, b].map(function (v) {
            v /= 255;
            return (v <= 0.03928) ?
                v / 12.92 :
                Math.pow(((v + 0.055) / 1.055), 2.4);
        });
        return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
    }

    contrastCheck(hex1, hex2) {
        var rgb1 = this.hexToRgb(hex1),
            rgb2 = this.hexToRgb(hex2),
            val1 = (this.luminanace(rgb1[0], rgb1[1], rgb1[2]) + 0.05),
            val2 = (this.luminanace(rgb2[0], rgb2[1], rgb2[2]) + 0.05);

        if (val1 > val2) {
            return (val1 / val2).toFixed(1);
        } else {
            return (val2 / val1).toFixed(1);
        }

    }

    colorResult(contrast) {
        if (contrast >= 0 && contrast < 3) { // fail
            return 'fail';
        } else if (contrast >= 3 && contrast < 4.5) {
            return 'aa-large';
        } else if (contrast >= 4.5 && contrast < 7) {
            return 'aa';
        } else if (contrast >= 7 && contrast <= 22) {
            return 'aaa';
        }
    }

    check() {
        const foreground = this.hexToHsl(this.foreground)
        const foregroundHex = this.hslToHex(foreground[0], foreground[1], foreground[2])

        const background = this.hexToHsl(this.background)
        const backgroundHex = this.hslToHex(background[0], background[1], background[2])

        const score = this.contrastCheck(foregroundHex, backgroundHex)

        return this.colorResult(score)
    }

    getRecommedColor() {

        const [h, s] = this.hexToHsl(this.foreground);
        const backgroundHex = this.hslToHex(...this.hexToHsl(this.background));

        let prevLevel = null;
        let recommended = null;

        for (let i = 0; i <= 10000; i++) {
            const currentL = i / 10000; // Lightness value from 0 to 1
            const currentHex = this.hslToHex(h, s, currentL);
            const hexScore = this.contrastCheck(backgroundHex, currentHex);
            const level = this.colorResult(hexScore);

            if (prevLevel && prevLevel !== level) {
                // Check for transitions between levels
                if (prevLevel === "aa" && level === "aaa") {
                    return currentHex; // Transition to AAA
                } else if (prevLevel === "aa" && level === "aa-large") {
                    recommended = currentHex; // Transition to AA-large
                } else if (level === "aa" && prevLevel === "aa-large") {
                    recommended = currentHex; // Transition to AA
                }
            }

            prevLevel = level;
        }

        return recommended;
    }
}

export default ColorConstrast
